
import { getNotificationCount, getSmsNotification, getTaskNotification } from "../../services/notificationPanelService";
import {
  GET_TASK_NOTIFICATION_SUCCESS,
  GET_TASK_NOTIFICATION_FAILURE,
  GET_SMS_NOTIFICATION_SUCCESS,
  GET_SMS_NOTIFICATION_FAILURE,
  GET_NOTIFICATION_COUNT_SUCCESS,
  GET_NOTIFICATION_COUNT_FAILURE,
  SET_SELECTED_TASK
} from "../actions/actionTypes";
import { START_LOADING, STOP_LOADING } from "../actions/actionTypes";
import { openSessionTimeoutModal } from './sessionTimeOutActions';


export const getTaskNotificationAction= (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_TASK_NOTIFICATION' });
    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getTaskNotification(page,size,token);
    dispatch({ type: STOP_LOADING, service: 'ALL_TASK_NOTIFICATION' });
    dispatch({ type: GET_TASK_NOTIFICATION_SUCCESS, payload: response });
  } catch (error) {
    if(error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'ALL_TASK_NOTIFICATION' });
      dispatch({ type: GET_TASK_NOTIFICATION_FAILURE, payload: error || 'All task service failed. Please try again.' });
    }
  }
};

export const setSelectedTask = (task) => ({

  type: SET_SELECTED_TASK,
  payload: {
    id: task.id,
    dueDate: task.dueDate,
    taskType: task.taskType,
    status: task.status,
    taskDescription: task.taskDescription,
    priority: task.priority,
    assignedToName: task.assignedToName,
  },
});


export const getSmsNotificationAction = (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    dispatch({ type: START_LOADING, service: 'ALL_SMS_NOTIFICATION' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getSmsNotification(page, size,token);

    dispatch({ type: STOP_LOADING, service: 'ALL_SMS_NOTIFICATION' });

    if (response?.unreadSmsAlerts?.length > 0) {
      dispatch({ type: GET_SMS_NOTIFICATION_SUCCESS, payload: response.unreadSmsAlerts });
    } else {
      console.warn("No unread SMS notifications found:", response);
      dispatch({ type: GET_SMS_NOTIFICATION_FAILURE, payload: "No unread SMS notifications." });
    }

  } catch (error) {
    if (error?.includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'ALL_SMS_NOTIFICATION' });
      dispatch({ type: GET_SMS_NOTIFICATION_FAILURE, payload: error || 'Failed to fetch SMS notifications.' });
    }
  }
};

export const getNotificationCountAction = (page = 0, size = 5) => async (dispatch, getState) => {
  try {
    // dispatch({ type: START_LOADING, service: 'ALL_COUNT_NOTIFICATION' });

    const token = getState().auth.token || sessionStorage.getItem("token");
    const response = await getNotificationCount(token, page, size);

    // dispatch({ type: STOP_LOADING, service: 'ALL_COUNT_NOTIFICATION' });

    if (typeof response === "number") {
      dispatch({ type: GET_NOTIFICATION_COUNT_SUCCESS, payload: response });
    } else {
      console.warn("Unexpected notifications count response:", response);
      dispatch({ type: GET_NOTIFICATION_COUNT_FAILURE, payload: "Invalid notifications count data." });
    }

  } catch (error) {
    if (String(error).includes("403")) {
      dispatch(openSessionTimeoutModal());
    } else {
      dispatch({ type: STOP_LOADING, service: 'ALL_COUNT_NOTIFICATION' });
      dispatch({ type: GET_NOTIFICATION_COUNT_FAILURE, payload: error || 'Failed to fetch count notifications.' });
    }
  }
};
